import Vue from "vue";
import App from "./App";
import router from "./router";
import "babel-polyfill";
import "lib-flexible";
import $ from "jquery";
import animated from "animate.css";
import VueAwesomeSwiper from "vue-awesome-swiper";
import "swiper/swiper-bundle.css";
import Pagination from "vue-pagination-2";
import VueLazyLoad from "vue-lazyload";
import SlideVerify from "vue-monoplasty-slide-verify";
import TopTitle from "./components/topTitle";
import "@/assets/font/font.css";
import Axios from "axios";
Vue.component("Top-Title", TopTitle);
Vue.use(SlideVerify);
Vue.use(VueLazyLoad, {
  error: "./static/lsxm.png",
  loading: "./static/loading.gif"
});
Vue.use(VueAwesomeSwiper);
Vue.use(animated);
Vue.component("pagination", Pagination);
Vue.config.productionTip = false;
Vue.prototype.$imgobj = []
new Vue({
  el: "#app",
  router,
  components: { App },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js